import { useState, useCallback } from 'react';
import { X } from 'lucide-react';

export function VisualizationEmbed({ html, title }: { html: string; title: string }) {
  const [expanded, setExpanded] = useState(false);

  const downloadHtml = useCallback(() => {
    const blob = new Blob([html], { type: 'text/html' });
    const link = document.createElement('a');
    const filename = title.replace(/[^a-zA-Z0-9]+/g, '_').replace(/^_|_$/g, '').toLowerCase() || 'visualization';
    link.download = `${filename}.html`;
    link.href = URL.createObjectURL(blob);
    link.click();
    URL.revokeObjectURL(link.href);
  }, [html, title]);

  return (
    <>
      <div className="mt-3">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm font-medium text-foreground/80">{title}</span>
          <div className="flex items-center gap-2">
            <button
              onClick={downloadHtml}
              className="text-[11px] text-muted-foreground/50 hover:text-primary transition-colors cursor-pointer px-1.5 py-0.5 rounded"
              title="Download as interactive HTML"
            >
              HTML
            </button>
            <button
              onClick={() => setExpanded(true)}
              className="text-[11px] text-muted-foreground/50 hover:text-primary transition-colors cursor-pointer flex items-center gap-1"
            >
              <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5v-4m0 4h-4m4 0l-5-5" />
              </svg>
              Expand
            </button>
          </div>
        </div>
        <div className="rounded-lg overflow-hidden border border-primary/10">
          <iframe
            srcDoc={html}
            sandbox="allow-scripts"
            style={{ width: '100%', height: 500, border: 'none', background: '#1a1a1a' }}
            title={title}
          />
        </div>
      </div>

      {/* Fullscreen overlay */}
      {expanded && (
        <div className="fixed inset-0 z-[100] bg-black/90 backdrop-blur-sm flex flex-col">
          <div className="flex items-center justify-between px-6 py-3 bg-card/80 border-b border-primary/20">
            <span className="text-sm font-medium text-foreground">{title}</span>
            <button
              onClick={() => setExpanded(false)}
              className="p-2 rounded-lg text-muted-foreground hover:text-foreground hover:bg-primary/10 transition-colors"
            >
              <X className="h-5 w-5" />
            </button>
          </div>
          <div className="flex-1">
            <iframe
              srcDoc={html}
              sandbox="allow-scripts"
              style={{ width: '100%', height: '100%', border: 'none', background: '#1a1a1a' }}
              title={title}
            />
          </div>
        </div>
      )}
    </>
  );
}
